export default __webpack_public_path__ + "static/media/Eota-Bulk-upload.864b3631.xlsx";